import type { ButtonHTMLAttributes, ReactNode } from 'react';
import styles from './Button.module.css';

type Variant = 'ghost' | 'solid' | 'warn';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  active?: boolean;
  children: ReactNode;
}

export function Button({ variant = 'ghost', active = false, className, ...rest }: ButtonProps) {
  const classes = [
    styles.button,
    variant === 'solid' ? styles.solid : '',
    variant === 'warn' ? styles.warn : '',
    active ? styles.active : '',
    className ?? '',
  ]
    .filter(Boolean)
    .join(' ');

  return <button type="button" className={classes} {...rest} />;
}

export function ButtonGroup({ children }: { children: ReactNode }) {
  return <div className={styles.group}>{children}</div>;
}
